import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Box,
    Slide,
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from "@mui/icons-material/Close";
import "./style.scss";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from "moment";
import { STATUS_CONFIG } from "../../../constants";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AlertPopup = ({ details, isCaseSucess }) => {
    const [modalType, setModalType] = useState("view_case");
    const [open, setOpen] = useState(false);
    const [detail, setDetail] = useState("");
    const normalizedStatus = isCaseSucess.toLowerCase();
    const config = STATUS_CONFIG[detail.status] || STATUS_CONFIG.failed;
    const isSuccess = detail && detail.status === "success" ? true : false;
    const isRunning = detail && detail.status === "running" ? true : false;

    const handleOpenPopup = () => setOpen(true);
    const onClose = () => { setOpen(false); setModalType("view_case") };

    useEffect(() => {
        if (open) {
            setModalType("view_case");
        }
    }, [open]);

    const renderContent = () => {
        switch (modalType) {
            case "view_case":
                return (
                    <>
                        <Typography className="case-assertions">
                            <b>Tests</b>:{details?.total_test_case},&nbsp;<b>Assertions</b>:{details?.passed_test_case},&nbsp;<b>Failures</b>:{details?.failed_test_case}.
                        </Typography>
                        {details?.reports.map((test, index) => {
                            const statusKey = test?.status?.toLowerCase();
                            const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG.failed;

                            return (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: 2,
                                        border: "1px solid #eee",
                                        borderRadius: "10px",
                                        padding: 2,
                                        mb: 2,
                                    }}
                                >
                                    <img
                                        src={test.type === "browser" ?
                                            test?.browser_name === "chrome" ? "/img/chrome.png" :
                                                test?.browser_name === "edge" ? "/img/browser.png" :
                                                    "/img/firefox.png"
                                            :
                                            "/img/backend.png"}
                                        alt="Logo"
                                        height="60"
                                    />
                                    <Box flex={1} sx={{ position: "relative" }}>
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight={600}
                                            sx={{ color: "#525252",textTransform:'capitalize' }}
                                        >
                                            {test.type === "browser" ? `${test.browser_name} Test Case` : "Backend Script"}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: config.color,
                                                fontWeight: 600,
                                                textTransform: 'capitalize'
                                            }}
                                        >
                                            {`Test Case ${test.status}`}
                                        </Typography>
                                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                                            {test.type === "browser"
                                                ? test.chrome_report || test.mozila_report || test.edge_report
                                                : test.script_report}
                                        </Typography>
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                right: 0,
                                            }}
                                        >
                                            <button
                                                style={{
                                                    border: "none",
                                                    background: "none",
                                                    fontWeight: "300",
                                                    color: "#030303",
                                                    fontSize: "13px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "6px",
                                                }}
                                                onClick={() => {
                                                    setDetail(test);
                                                    setModalType(
                                                        modalType === "view_case" && test.type === "browser"
                                                            ? "View Screenshot"
                                                            : "View Results"
                                                    );
                                                }}
                                            >
                                                <img
                                                    src="/img/view.png"
                                                    alt="View Logo"
                                                    height="20"
                                                    width="20"
                                                />
                                                {test.type === "browser" ? "View Screenshot" : "View Results"}
                                            </button>
                                        </div>
                                    </Box>
                                </Box>
                            );
                        })}

                    </>
                );
            case "View Screenshot":
                return detail ? (
                    <>
                        <Typography sx={{ mb: 2 }}>
                            <strong>Summary:</strong>{" "}
                            {detail.chrome_report
                                ? detail.chrome_report
                                : detail.mozila_report
                                    ? detail.mozila_report
                                    : detail.edge_report}
                        </Typography>

                        <Typography sx={{ mb: 1 }}>
                            {isSuccess ? "SUCCESS!" : isRunning ? "RUNNING!" : "FAILURES!"}
                            <br />
                            {/* Tests: {detail.failuresData.tests},{" "}
                            {detail.failuresData.success ? "Success" : "Assertions"}:{" "}
                            {detail.failuresData.success
                                ? detail.failuresData.success
                                : detail.failuresData.assertions}
                            , Failures: {detail.failuresData.failures}. */}
                        </Typography>

                        <Typography sx={{ fontWeight: 600, mt: 2, mb: 1 }}>
                            {detail.key} Browser
                        </Typography>

                        <Typography
                            sx={{
                                background: "#F0F0F0",
                                padding: 2,
                                borderRadius: 2,
                                mb: 2,
                            }}
                        >
                            <img
                                src={
                                    isSuccess
                                        ? "/img/accordian.png"
                                        : "/img/accordian2.png"
                                }
                                alt="Form Screenshot"
                                style={{ width: "100%", borderRadius: 8 }}
                            />
                        </Typography>
                    </>
                ) : null;

            case "View Results":
                return (
                    <>
                        <Typography sx={{ mb: 2 }}>
                        <strong>Time:</strong> {(detail.time) ? detail.time : null},{" "}
                        <strong>Memory:</strong> {detail.memory}
                        </Typography>
                        <Typography
                            sx={{
                                mb:
                                    !isSuccess
                                        ? 2
                                        : 3,
                            }}
                        >
                            {isSuccess ? "SUCCESS!" : isRunning ? "RUNNING!" : "FAILURES!"}
                            <br />
                            {/* Tests:{detail.failuresData.tests}, Assertions:
                            {detail.failuresData.assertions} , Failures:
                            {detail.failuresData.failures} . */}
                        </Typography>

                    </>
                );
            default:
                return <Typography>No content to display.</Typography>;
        }
    };
    return (
        <>

            <VisibilityIcon
                sx={{
                    color: STATUS_CONFIG[isCaseSucess],
                    mr: 2,
                    cursor: 'pointer'
                }}
                onClick={handleOpenPopup}
            />
            <Dialog
                open={open}
                keepMounted
                onClose={onClose}
                TransitionComponent={Transition}
                className={modalType === "View Screenshot" ? "alert_screenshot_popup" : "alertPopup"}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {modalType !== "view_case" && (
                        <>
                            <IconButton
                                title="back"
                                onClick={() => setModalType("view_case")}
                                sx={{ mr: 1, paddingLeft: "0px" }}
                            >
                                <KeyboardBackspaceIcon style={{ color: "black" }} />
                            </IconButton>
                            <InfoIcon fontSize="large" sx={{ color: config.icon }} />
                        </>
                    )}
                    <strong style={{ marginLeft: "10px", textTransform:'capitalize' }}>
                        {modalType === "View Results"
                            ? isSuccess
                                ? `Some Test Case Success` :
                                isRunning ? `Some Test Case Running`
                                    : "Some Test Case Failed"
                            : modalType === "View Screenshot"
                                ? isSuccess
                                    ? `Test Case Success on ${detail?.browser_name}` :
                                    isRunning ? `Test Case Running on ${detail?.browser_name}`
                                        : `Test Case Failed on ${detail?.browser_name}`
                                : ""}
                    </strong>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>{renderContent()}</DialogContent>
            </Dialog>
        </>
    );
};

export default AlertPopup;
